import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth, type UserRole } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Si se especifica, solo estos roles pueden acceder */
  roles?: UserRole[];
}

/**
 * Wrapper que protege rutas que requieren autenticacion.
 *  - Si no hay sesion, redirige a /auth/login y guarda la ruta original
 *  - Si hay sesion pero el rol no esta permitido, redirige al dashboard
 *  - Mientras carga, muestra un spinner centrado
 */
export default function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const { session, profile, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!session) {
    return <Navigate to="/auth/login" state={{ from: location.pathname }} replace />;
  }

  if (roles && profile && !roles.includes(profile.rol)) {
    // Usuario sin permiso para esta ruta -> al dashboard
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
